// Copyright (c) 2020 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as TagsSlice from "../slice"
import { SearchTagsRequest, SearchTagsResponse } from "generated/legebill/site/tag/v4/tag_pb"
import { grpc } from "app/rpc/executor"
import { tagServiceClient } from "app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type SearchTagsRpc = (request: SearchTagsRequest) => Observable<SearchTagsResponse>

export const searchTags = (searchTagsRpc: SearchTagsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchTags.match),
      mergeMap(({ payload }) => of(payload)
        .pipe(
          mergeMap(searchTagsRpc),
          map(t => t.toObject()),
          map(response => TagsSlice.setResultTags({ searchString: payload.getSearchText(), response })),
          catchError(_ => concat(
            of(TagsSlice.resetResultTags()),
            of(showSnackBar({
              message: t({
                id: "msg_search_tags_failed",
                message: "Failed to search for tags. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
              }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const searchTagsRpc = (request: SearchTagsRequest): Observable<SearchTagsResponse> =>
  grpc(() => tagServiceClient.searchTags(request, null))

export default searchTags(searchTagsRpc)
